export const setStorage = (cname: string, cvalue: string) => {
  localStorage.setItem(cname, cvalue);
};
export const getStorage = (cname: string) => {
  return localStorage.getItem(cname);
};
export const removeStorage = (cname: string) => {
  localStorage.removeItem(cname);
};
